// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-widget[data-v-ce36a462]{padding:1rem}.regular-drop-down[data-v-ce36a462]{border:1px solid #000;border-radius:0px;color:#000;background:#fff;padding:.2rem .5rem;height:2.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
